

























import Vue from 'vue'
import { LogService } from '@/api/services/logs'

interface Log {
  id?: number
  dateTime: string
  information: string
  responsible: string
}

interface ComponentData {
  columns: Record<string, string | boolean>[]
  currentItemId: string | number | null
  logs: any[]
  total: number | undefined
  pagination: {
    page: number
    perPage: number
  }
}

export default Vue.extend({
  data(): ComponentData {
    return {
      columns: [
        {
          label: 'Date et Heure',
          field: 'createdAt'
        },
        {
          label: 'Information',
          field: 'text',
          searchable: true
        },
        {
          label: 'Responsable',
          field: 'causer.fullname',
          searchable: true
        }
        // {
        //   label: 'Action',
        //   field: '_action',
        //   align: 'right'
        // }
      ],
      currentItemId: '',
      logs: [],
      total: undefined,
      pagination: {
        page: 1,
        perPage: 10
      }
    }
  },

  // computed: {
  //   logs() {
  //     return Logs.query()
  //       .with('causer')
  //       .orderBy('createdAt', 'desc')
  //       .all()
  //   }
  // },

  // created() {
  //   Logs.api().fetch()
  // },

  async mounted() {
    this.fetchData()
  },

  methods: {
    onSeeDetails() {
      // TODO: Write route to details page
      // this.$router.push({ name: 'logs.details', params: { logId: id } })
    },

    async fetchData() {
      const response = await LogService.findAll(this.pagination)
      this.logs = response.result
      this.total = response.count
    },
    onPrev() {
      if (this.pagination.page > 1) {
        this.pagination.page--
        this.fetchData()
      }
    },
    onNext() {
      if (
        this.total &&
        this.pagination.page * this.pagination.perPage < this.total
      ) {
        this.pagination.page++
        this.fetchData()
      }
    }
  }
})
